import type React from 'react';
import { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import CloseIcon from 'assets/icons/icn _ 24px  _ close_dialog.svg?react';
import AlertIcon from 'assets/icons/icn _ 24px _ alert.svg?react';
import { useStyles } from 'components/alert/styles';

export interface TMXAlertProps {
  className?: string;
  icon?: boolean;
  iconSvg?: React.ReactNode;
  dismissable?: boolean;
  onClose?: () => void;
  open?: boolean;
}

const TMXAlert: React.FC<React.PropsWithChildren<TMXAlertProps>> = ({
  children,
  className,
  icon,
  iconSvg,
  dismissable = false,
  onClose,
  open = true,
}) => {
  const { classes } = useStyles();
  const [isShowing, setIsShowing] = useState<boolean>(open);
  const handleClose = () => {
    setIsShowing(dismissable ? false : open);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setIsShowing(open);
  }, [open]);

  return (
    <>
      {isShowing && (
        <Grid item className={className}>
          <Grid
            container
            className={`${classes.alertWrapper} ${dismissable ? classes.dismissableAlert : ''}`}
            direction="row"
            spacing={2}
            wrap="nowrap"
          >
            {dismissable && <CloseIcon className={classes.dismissIcon} onClick={handleClose} />}
            {icon && (
              <Grid item className={classes.alertIconWrapper}>
                {iconSvg ? iconSvg : <AlertIcon />}
              </Grid>
            )}
            <Grid item xs className={classes.alertTextWrapper}>
              {typeof children === 'string' ? <Typography>{children}</Typography> : children}
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default TMXAlert;
